import { Menu } from "antd";
import styled from "styled-components";


const { Item } = Menu;
export const ItemMenu = styled(Item)`
    line-height: 15px !important;
    text-align: left;
    cursor:unset;
`;